export default {
  mobileWidth: 1024, // mobile device screen width
  smallScreenWidth: 768, // small mobile device screen width
  pcModalWidth: 680, // pc device, antd modal width
  mobileModalWidth: "91.46%", // mobile device, antd modal width
};
